<template>
	<div class="x-table-container">
		<ATable :columns="columnsFilter" :data-source="dataListFilter" :row-key="rowKey" bordered size="small"
			:row-selection="selectType ? {
        ...rowSelection,
        selectedRowKeys: selectedKeys || ownSelectKeys
      } : null" :loading="loading" :custom-row="customRow" :pagination="paginationConfig" @change="changeHandler"
			v-bind="$attrs">
			<!-- 自定义表格渲染项 -->
			<template v-for="scopedSlot in scopedSlots" v-slot:[scopedSlot.customRender]="cellData, record,index">
				<!-- 填充类型 -->
				<template v-if="scopedSlot.type == 'fill' && cellData">
					<div :key="scopedSlot.key" :class="[`${cellData.badgeClass}`]">{{ cellData.name }}</div>
				</template>
				<!-- 标签类型 -->
				<template v-else-if="scopedSlot.type == 'tag' && cellData">
					<ATag :key="scopedSlot.key" :class="[`tag-${cellData.badgeClass}`]">{{ cellData.name }}</ATag>
				</template>
				<!-- 日期类型 -->
				<template v-else-if="scopedSlot.type == 'date'">
					<div :key="scopedSlot.key">{{ cellData && $moment(cellData).format('YYYY-MM-DD') }}</div>
				</template>
				<!-- 日期-时间类型 -->
				<template v-else-if="scopedSlot.type == 'dateTime'">
					<div :key="scopedSlot.key">{{ cellData && $moment(cellData).format('MM-DD HH:mm') }}</div>
				</template>
				<!-- 可编辑 -->
				<template v-else-if="scopedSlot.type == 'edit'">
					<input class="input" :key="scopedSlot.key" v-model="editList[index]" />
				</template>
				<!--文件图标-->
				<template v-else-if="scopedSlot.type=='fileIcon'&&record.name">
					<img :key="scopedSlot.key" :src="$docUtils.docIconHandler(record.name)" />
				</template>
				<template v-else>
					<slot :name="scopedSlot.customRender" :id="record && record[rowKey]" :record="record"
						:cellData="cellData"></slot>
				</template>
			</template>
			<slot></slot>
		</ATable>
	</div>
</template>
<script>
	export default {
		props: {
			/** 列配置 */
			columns: [],
			/** 自定义表头接口 */
			headApi: Function,
			/** 数据接口 */
			dataApi: Function,
			/** 数据列表 */
			dataSource: Array,
			/** 条件参数 */
			params: Object,
			/** 数据格式化 */
			dataFormat: Function,
			/** 选择类型 */
			selectType: String,
			/** 选中列表 */
			selectedKeys: Array,
			/** 是否选中第一个 */
			selectFirst: Boolean,
			/** 工单类型 */
			workOrderType:{
				type: String,
				default:null
			},
			/** 每页数量 */
			pageSize: {
				type: Number,
				default: 5
			},
			/** 是否进行分页 */
			paging: {
				type: Boolean,
				default: true,
			},
			/** 分页参数类型 1：pageNo、pageSize 2：page、limit */
			pagingType: {
				default: 1
			},
			/** 数据主键 */
			rowKey: {
				default: "id"
			},
			/** 展示序号宽度 传入空则不展示 */
			indexWidth: {
				default: 50
			},
			/** 编辑列表 */
			editList:{
				type: Array,
			},
		},
		data() {
			return {
				ownColumns: [],
				dataList: [],
				loading: true,
				rowSelection: {
					type: this.selectType,
					onChange: this.selectChange,
					selectedRowKeys: this.selectedKeys || [],
				},
				//自有选择项列表
				ownSelectKeys: [],
				pagination: {
					current: 1, //当前页码
					total: 0, //总数量
				}
			};
		},
		computed: {
			/** 配置项处理 */
			columnsFilter() {
				if (!this.columns) return null
				return this.$tableUtils.columnsHandler(this.columns, this.pagination.current, this.pageSize, this.rowKey,
					this.indexWidth)
			},
			/** 动态插槽 */
			scopedSlots() {
				return this.$tableUtils.dynamicSlotHandler(this.columns)
			},
			/** 分页配置 */
			paginationConfig() {
				// if (this.dataSource) {
				// 	return false
				// }
				if (!this.paging) {
					return false
				}
				return {
					current: this.pagination.current,
					pageSize: this.pageSize,
					total: this.pagination.total,
					size: 'large',
					itemRender: (page, type, node) => {
						if (type === 'prev') {
							return <a class = "ant-pagination-item mr0 plr10" > 上一页 </a>
						}
						if (type === 'next') {
							return <a class = "ant-pagination-item plr10 mr0" > 下一页 </a>
						}
						return node
					}
				}
			},
			/** 集合处理 */
			dataListFilter() {
				let realDataList = this.dataSource || this.dataList
				let dataList = []
				dataList.push(...realDataList)
				this.fillDataListHandler(dataList)
				return dataList
			},
			/** 是否为单选 */
			isRadio() {
				return this.selectType == 'radio'
			}
		},
		created() {
			this.init()
		},
		mounted() {},
		methods: {
			/** 初始化 */
			async init() {
				this.$tableUtils.columnsConvert(this.headApi, this.columns)
				this.searchList()
				if(this.selectFirst){
					//选中首个数据
					let firstKey = this.dataListFilter?.[0]?.[this.rowKey]
					firstKey && firstKey > 0 && this.ownSelectKeys.push(firstKey)
				}
			},
			/** 查询列表 */
			searchList(clear) {
				clear && this.clearSelection()
				if (!this.dataApi) {
					this.loading = false
					return
				}
				this.loading = true
				this.dataApi({
					...this.params,
					...this.pagingParam(),
					workOrderType:this.workOrderType
				}).then(({ data }) => {
					this.loading = false
					//兼容分页与不分页情况
					let dataList = data.data || data || []
					this.dataList = this.dataFormat ? this.dataFormat(dataList) : dataList
					this.pagination.total = data.total || 0
					this.$emit("searchAfter", data)
				}).catch(() => {
					this.loading = false
				})
			},
			/** 重置并且搜索 */
			resetSearchList() {
				this.pagination.current = 1
				this.searchList(true)
			},
			/** 分页参数类型 */
			pagingParam() {
				switch (this.pagingType) {
					case 1:
						return {
								pageNo: this.pagination.current,
								pageSize: this.pageSize,
						}
						case 2:
							return {
									page: this.pagination.current,
									limit: this.pageSize
							}
				}
			},
			/** 行事件配置 */
			customRow(record, index) {
				return {
					on: {
						click: () => this.rowClick(record, index), //单击事件
					},
				}
			},
			/** 行点击事件 */
			rowClick(record) {
				const key = record[this.rowKey]
				if (key < 0) return
				if (!this.selectType) return
				//单选框
				if (this.isRadio) {
					this.ownSelectKeys = []
					this.ownSelectKeys.push(key)
				} else {
					//多选框
					const index = this.ownSelectKeys.indexOf(key)
					index != -1 ? this.ownSelectKeys.splice(index, 1) : this.ownSelectKeys.push(key)
				}
				this.selectChange(this.ownSelectKeys)
			},
			/** 选择项项改变 */
			selectChange(selectedRowKeys) {
				//过滤不能选择的项
				selectedRowKeys = selectedRowKeys.filter(item => item > 0)
				this.ownSelectKeys = selectedRowKeys
				let key = this.ownSelectKeys
				let row = null
				if (this.isRadio) {
					key = key[0]
					row = this.dataListFilter.find(item => item[this.rowKey] == key)
				}
				this.$emit("select-change", key, row)
			},
			/** 清除选择项 */
			clearSelection() {
				this.selectChange([])
			},
			/** 分页、排序、筛选变化时触发 */
			changeHandler(page) {
				this.pagination.current = page.current
				this.searchList()
			},
			/** 数据列表补全处理 */
			fillDataListHandler(dataList) {
				//需要补全的数量
				const residueCount = this.pageSize - dataList.length
				let fillList = []
				for (let i = 0; i < residueCount; i++) {
					let obj = {}
					obj[this.rowKey] = -1 - i
					fillList.push(obj)
				}
				dataList.push(...fillList)
			},
			/** 获取选择项数据 */
			getSelectionData() {
				let idData = null,
					rowData = null
				//单选框
				if (this.isRadio) {
					if (this.ownSelectKeys.length > 0) {
						idData = this.ownSelectKeys[0]
						rowData = this.findRowDataByKey(idData)
					}
				} else { //复选框
					idData = this.ownSelectKeys
					rowData = []
					this.ownSelectKeys.forEach(key => {
						rowData.push(this.findRowDataByKey(key))
					})
				}
				return { idData, rowData }
			},
			/** 根据主键获取行数据 */
			findRowDataByKey(key) {
				if (!key) return null
				return this.dataListFilter.find(item => item[this.rowKey] == key)
			},
		},
		watch: {
			selectedKeys() {
				// console.log(this.selectedKeys)
			}
		}
	};
</script>
<style lang="less" scoped>
	/deep/.ant-table-wrapper {
		.ant-empty-normal {
			margin-bottom: 50px;

			.ant-empty-description {
				display: none;
			}

			.ant-empty-image::after {
				display: block;
				content: "暂无数据";
			}
		}

		th {
			font-size: 25px;
			&.fill {
				padding: 8px !important;
			}
		}

		td {
			font-size: 25px;
			height: 35px;
		}

		.fill {
			padding: 0 !important;

			>div {
				height: 100%;
				width: 100%;
				color: #fff;
				display: flex;
				align-items: center;
				justify-content: center;
				// background-color: inherit;
				padding: 8px 8px;
			}

			input {
				height: 100%;
				width: 100%;
			}
		}
	}
	/deep/.edit{
		padding:0 !important;
		.input{
			height: 100%;
			width: 100%;
			border:none;
		}
	}
</style>
